import { Entity } from "@rest-hooks/endpoint";
export class HouseOwnerEntity extends Entity {
    constructor() {
        super();
        this.houseOwnerId = 0;
        this.uniquePropertyId = "";
        this.applicationPropertyId = 0;
        this.organizationNumber = "";
        this.personalNumber = "";
        this.name = "";
        this.email = "";
        this.phone = "";
        this.isNorwegianCitizen = false;
        this.owningFractionNumerator = 0;
        this.owningFractionDenominator = 0;
        this.isResident = false;
        this.displayValue = "";
        this.houseOwnerId = 0;
        this.uniquePropertyId = "";
        this.applicationPropertyId = 0;
        this.dateOfBirth = new Date();
        this.organizationNumber = "";
        this.personalNumber = "";
        this.name = "";
        this.email = "";
        this.phone = "";
        this.isNorwegianCitizen = false;
        this.owningFractionNumerator = 0;
        this.owningFractionDenominator = 0;
        this.isResident = false;
        this.displayValue = "";
    }
    pk(parent, key) {
        return this.houseOwnerId.toString();
    }
}
export class LienEntity extends Entity {
    constructor() {
        super();
        this.lienId = 0;
        this.uniquePropertyId = "";
        this.creditorOrgNo = "";
        this.creditorName = "";
        this.priority = "";
        this.yieldPriority = false;
        this.writtenDownValue = 0;
        this.addedManually = false;
        this.documentId = "";
        this.registrationDate = undefined;
        this.lienType = "";
        this.infoAsText = "";
        this.value = 0;
        this.reuseLien = false;
        this.expirationDate = undefined;
        this.lienId = 0;
        this.uniquePropertyId = "";
        this.creditorOrgNo = "";
        this.creditorName = "";
        this.priority = "";
        this.yieldPriority = false;
        this.writtenDownValue = 0;
        this.documentId = "";
        this.addedManually = false;
        this.registrationDate = undefined;
        this.expirationDate = undefined;
        this.lienType = "";
        this.infoAsText = "";
        this.value = 0;
        this.reuseLien = false;
    }
    pk(parent, key) {
        return this.lienId?.toString() ?? "";
    }
}
export class SpecialConstraintEntity extends Entity {
    constructor() {
        super();
        this.specialConstraintId = 0;
        this.documentId = "";
        this.registrationDate = new Date();
        this.name = "";
        this.warningLevel = undefined;
        this.isJudicialRegistered = undefined;
    }
    pk(parent, key) {
        return this.specialConstraintId?.toString();
    }
}
export class ApplicationPropertyEntity extends Entity {
    constructor() {
        super();
        this.applicationPropertyId = 0;
        this.applicationId = 0;
        this.propertyInformation = "";
        this.uniquePropertyId = "";
        this.type = "Unknown";
        this.cadastralNumber = "";
        this.streetName = undefined;
        this.addressNumber = undefined;
        this.addressLetter = undefined;
        this.municipalityNumber = undefined;
        this.postalCode = undefined;
        this.postalPlace = undefined;
        this.unitNumber = undefined;
        this.leaseholdUnitNumber = undefined;
        this.refinance = undefined;
        this.valueEnteredByCustomer = undefined;
        this.mainCustomerResidence = undefined;
        this.estimatedValue = undefined;
        this.pledgeValue = undefined;
        this.cadastralUnitNumber = undefined;
        this.housingCooperativeOrgNumber = undefined;
        this.housingCooperativeOrgName = undefined;
        this.shareNumber = undefined;
        this.housingCooperativeName = undefined;
        this.jointDebt = undefined;
        this.businessManager = undefined;
        this.apartmentNumber = undefined;
        this.utilizedValue = undefined;
        this.utilizedSecurityValue = undefined;
        this.freeText = undefined;
        this.owners = [new HouseOwnerEntity()];
        this.liens = [new LienEntity()];
        this.newLiens = [new LienEntity()];
        this.specialConstraints = [new SpecialConstraintEntity()];
        this.eAppraisalReference = undefined;
        this.eAppraisalDate = undefined;
        this.priority = undefined;
        this.deleteCadastral = undefined;
        this.addedManually = undefined;
    }
    pk(parent, key) {
        return (this.propertyInformation?.toString() + this.uniquePropertyId?.toString());
    }
}
//# sourceMappingURL=ApplicationPropertyEntities.js.map